const authInfo = localStorage.getItem("__EMS_AUTH_INFO");
const accessToken = localStorage.getItem("__EMS_ACCESS_TOKEN");

const auth = {
    state: {
        authInfo: authInfo ? JSON.parse(authInfo) : null,
        accessToken: accessToken ? accessToken : '',
        userRole: authInfo ? JSON.parse(authInfo).role : '',
        refreshToken: authInfo ? JSON.parse(authInfo).refreshToken : '',
        isLoggedIn: authInfo !== null,
    },
    getters: {
        isLoggedIn: (state) => {
            return state.isLoggedIn;
        },
        authUser: (state) => {
            return state.authInfo;
        },
        accessToken: (state) => {
            return state.accessToken;
        },
        userRole: (state) => {
            return state.userRole;
        },
        refreshToken: (state) => {
            return state.refreshToken;
        },
    },
    mutations: {
        LOGIN_SUCCESS: (state, request) => {
            localStorage.setItem("__EMS_AUTH_INFO", JSON.stringify(request));
            localStorage.setItem("__EMS_ACCESS_TOKEN", request.access_token);
            state.isLoggedIn = true;
            state.authInfo = request;
            state.accessToken = request.token;
            state.userRole = request.role;
            state.refreshToken = request.refreshToken;
        },
        UPDATE_TOKEN: (state, request) => {
            state.accessToken = request.token;
            localStorage.setItem("__EMS_ACCESS_TOKEN", request.token);
        },
        LOGOUT: (state) => {
            localStorage.removeItem("__EMS_AUTH_INFO");
            localStorage.removeItem("__EMS_ACCESS_TOKEN");
            localStorage.setItem("__themeMode", 'light');
            state.isLoggedIn = false;
            state.authInfo = null;
            state.accessToken = "";
            state.userRole = "";
            state.refreshToken = "";
        },
    },
    actions: {
        login(context, request) {
            context.commit("LOGIN_SUCCESS", request);
            return Promise.resolve(request);
        },

        logout(context) {
            return context.commit("LOGOUT");
        },

        refreshToken(context, request) {
            localStorage.removeItem("__EMS_ACCESS_TOKEN");
            context.commit("UPDATE_TOKEN", request);
            return Promise.resolve(request);
        },
    },
};

export default auth;
